import React, { useState, useEffect } from 'react';

import './MenuComponent.scss';
import {ItemMenuLog} from "../../services/interactions/elements/itemmenu";

function ItemMenu({ children, actionWillRedirect, forceCloseSubject, fixed, onOpen, onClose }) {
    const [opened, setOpened] = useState(false);
    const [position, setPosition] = useState({top: '0px', right: '0px'});
    const optionsElement = React.createRef();

    useEffect(() => {
        if(forceCloseSubject){
            const subs = forceCloseSubject.subscribe(() => {
                close();
            })
            return () => {
                subs.unsubscribe();
            }
        }
    }, [forceCloseSubject])

    const getWindowDimensions = () => {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height
        };
    }

    const updatePosition = (e) => {
        const windowDimensions = getWindowDimensions();
        const position = e.target.getBoundingClientRect();
        const right = windowDimensions.width - position.left;
        const height = optionsElement.current.offsetHeight;
        let top = e.clientY;
        if (top + height > windowDimensions.height) {
            top = windowDimensions.height - height;
        }
        setPosition({
            top: top+'px',
            right: right+'px'
        })
    }

    const open = (e) => {
        if (fixed) {
            updatePosition(e);
        }
        if (onOpen) {
            onOpen();
        }
        setOpened(true);
    }
    
    const close = () => {
        if (onClose) {
            onClose();
        }
        setOpened(false);
    }

    const pseudoBlur = () => {
        if(actionWillRedirect){
            // Avoids setState on unmounted ItemMenu error
            return;
        }
        close();
    }

    const getStyle = () => {
        if (!fixed) {
            return {};
        }
        return position;
    }

    return (
        <div className="__ItemMenu">
            <div className="_trigger" onClick={open}>
                <i className="material-icons">more_vert</i>
            </div>
            {
                opened ?
                    <div className="_itemOverlay" onClick={close}></div>
                    : ''
            }
            <div ref={optionsElement} className={`_contentCollapse ${opened ? 'opened' : 'closed'} ${fixed ? 'fixed' : ''}`} onClick={pseudoBlur} style={getStyle()}>
                {children}
            </div>
        </div>
    )
}

export default ItemMenuLog(ItemMenu);
